import { type FetchPledgeTeamsData, type FetchPledgeTeamsParams, minutesToMs, pledgeApi } from '@capsicum/common';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

type UsePledgeTeamsQueryProps = {
	options?: Omit<UseQueryOptions<FetchPledgeTeamsData>, 'queryFn' | 'queryKey'>;
	params?: FetchPledgeTeamsParams;
};

export const usePledgeTeamsQuery = ({ options = {}, params = {} }: UsePledgeTeamsQueryProps = {}) => {
	return useQuery({
		queryFn: async () => {
			return (await pledgeApi).fetchPledgeTeams(params) as Promise<FetchPledgeTeamsData>;
		},
		queryKey: ['pledge-teams', params],
		staleTime: minutesToMs(5),
		...options,
		select: res => res.data
	});
};
